import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _AttantionTriangleCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "#ff6565", d: "M.909 20.486 11.143 3.428a1 1 0 0 1 1.714 0l10.234 17.057A1 1 0 0 1 22.234 22H1.766a1 1 0 0 1-.857-1.515" }),
            React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.207 17.47c.056.304.394.53.792.53s.736-.226.792-.53l.148-.787C13.302 14.761 14 11.068 14 10.185 14 9.414 13.496 8 11.999 8 10.5 8 10 9.414 10 10.185c0 1.225.597 4.21.973 6.093.097.488.18.902.234 1.192m.726.855a1 1 0 1 0 0 2 1 1 0 0 0 0-2", clipRule: "evenodd" })));
}
const AttantionTriangleCustom = forwardRef(_AttantionTriangleCustom);
export { AttantionTriangleCustom };
